__turbopack_context__.v({
  "button": "InfoBox-module__SJL_wW__button",
  "container": "InfoBox-module__SJL_wW__container",
  "content": "InfoBox-module__SJL_wW__content",
  "icon": "InfoBox-module__SJL_wW__icon",
});
